<template>
  <section class="mb-4">
    <div
      v-if="isLoading"
      class="loading-message"
    >
      <b-spinner
        variant="success"
        style="width: 3rem; height: 3rem;"
        label="Large Spinner Text Centered"
      /> <strong>Sending please wait...</strong>
    </div>
    <p class="text-center w-responsive mx-auto mb-3 mt-4">
      Do you have any questions? Please do not hesitate to contact us directly.
      Our team will get in touch with you shortly.
    </p>

    <div class="container">
      <p
        v-if="sent"
        class="text-center text-success"
      >
        Feedback is submitted
      </p>
      <p
        v-if="errorMessage"
        class="text-center text-infor"
      >
        Something went wrong. Please contact us directly at <strong>djuli@zimmerpeacock.com</strong>
        via email
      </p>
      <p
        v-if="isValid"
        class="text-center text-danger"
      >
        Please validate the inputs.
      </p>
      <form @submit.prevent="submitFeedback">
        <b-form-group
          label="Your Name:"
          label-for="name-text"
        >
          <b-form-input
            id="name-text"
            v-model.trim="name"
            type="text"
            :state="name===''||name.length>3"
            required
            placeholder="Write your name"
          />
          <b-form-invalid-feedback class="input-live-feedback">
            The name must contain at least 3 characters
          </b-form-invalid-feedback>
        </b-form-group>
        <label>Type of Request</label>
        <select
          id="request"
          v-model="selectFeedback"
          name="request"
        >
          <option value="New Functionality Request">
            Request New functionality
          </option>
          <option value="Bug Error Reported">
            Report Bug/Error
          </option>
          <option value="Improvement Suggested">
            Suggest Improvement
          </option>
        </select>
        <textarea
          id="message-text"
          v-model.trim="feedbackMessage"
          :class="{ 'input-message-error': feedbackMessage!==''&&feedbackMessage.length<30 }"
          required
          placeholder="Write your message..."
          name="message"
          class="input-message mb-0 pb-0"
        />
        <p
          v-if="feedbackMessage!==''&&feedbackMessage.length<30"
          class="text-start text-danger m-0 p-0"
        >
          The message must contain at least 30 characters
        </p>
        <input
          ref="fileInput"
          type="file"
          multiple
          class="pt-4"
          @change="uploadFile"
        >

        <input
          type="submit"
          value="Submit"
        >
      </form>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      name: '',
      selectFeedback: 'New Functionality Request',
      feedbackMessage: '',
      files: null,
      sent: false,
      isValid: false,
      errorMessage: false,
			isLoading: false,
    };
  },

  methods: {
    uploadFile(event) {
      this.files = event.target.files;
    },

    submitFeedback() {
			this.isLoading = true;
      if (this.feedbackMessage.length > 30 && this.name.length > 3) {
        const token = localStorage.getItem('accesstoken');
        const formData = new FormData();
        if (this.files != null || this.files != undefined) {
          for (const i of Object.keys(this.files)) {
            formData.append('files', this.files[i]);
          }
        }
        formData.append('name', this.name);
        formData.append('message', this.feedbackMessage);
        formData.append('linkActionSubject', this.selectFeedback);
        axios
          .post('api/v0/send', formData, {
            headers: {
              'Content-Type': 'multipart/form-data', //'application/json',
              Authorization: `Bearer ${token}`,
            },
          })
          .then(() => {
            this.name = '';
            this.feedbackMessage = '';
            this.files=null
            this.sent = true;
            this.isValid = false;
            this.errorMessage = false;
            this.$refs.fileInput.value='';
						this.$alert(
						'Your feedback is submitted successfully',
								'Request Successful!',
								'success',
							);
							this.isLoading = false;
          })
          .catch((error) => {
						console.error(error)
            this.errorMessage = true;
						this.isLoading =false;
          });
      } else {
        this.isValid = true;
        this.sent = false;
        this.errorMessage = false;
      }
    },
  },
};
</script>

<style scoped>
.bd-placeholder-img {
  font-size: 1.125rem;
  text-anchor: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

@media (min-width: 768px) {
  .bd-placeholder-img-lg {
    font-size: 3.5rem;
  }
}
input[type="text"],
select,
textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid rgb(19, 175, 39);
  border-radius: 4px;
  box-sizing: border-box;
  margin-top: 6px;
  margin-bottom: 16px;
  resize: vertical;
}

select{
      background: white;
}

input[type="submit"] {
  background-color: rgb(15, 155, 50);
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  left: 50%;
}

input[type="submit"]:hover {
  background-color: green;
  color: wheat;
}
.container {
  max-width: 960px;
}
.site-header {
  background-color: rgba(39, 173, 100, 0.85);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  backdrop-filter: saturate(180%) blur(20px);
}
.site-header a {
  color: #8e8e8e;
  transition: color 0.15s ease-in-out;
}
.site-header a:hover {
  color: #fff;
  text-decoration: none;
}

.flex-equal > * {
  flex: 1;
}
@media (min-width: 768px) {
  .flex-md-equal > * {
    flex: 1;
  }
}
.input-message{
  height:20rem;
}
.input-message-error{
  border: red 2px solid !important;
}
.loading-message {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(255, 255, 255, 0.8);
  padding: 20px;
  border-radius: 10px;
  text-align: center;
}
</style>
